<template>
  <section id="indicators">
      <main style="text-align:left;white-space:normal">
        <div class="title">
            <icon icoClass='title-ico' selected='indicators'/>
            {{$t('indicators')}}
            <span v-if="paginationFilters[index] && paginationFilters[index].period == 'T'" class="sub-title">
              {{$t(trimester[Math.ceil(((new Date()).getMonth()+1)/3)-1])}} {{$t('trimester')}}
            </span>
        </div>
        <div class="indicators">
            <indicator v-for="(indicator, index) in indicators" :key="index"
                :title="indicator.type.description"
                :value="indicator.value"
                :svg="indicator.type.icon?indicator.type.icon.icon:undefined"
                :grow="indicator.growth"
                :grade_growth="indicator.grade_growth"/>
        </div>
      </main>
    </section>
</template>

<script>
import icon from './../svg/tabs'
import Indicator from '../components/Indicator'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'indicators',
  components: {Indicator, icon},
  props: {
  },
  created () {
    this.$emit('loading')
  },
  mounted () {
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        // eslint-disable-next-line
        if (this.$route.name != 'indicators') {
          clearInterval(this.timer)
        } else if (this.userData.roles && this.userData.roles.map((x) => { return x.id }).indexOf(this.kioskId) > -1) {
          ++this.index
          if (this.index >= this.paginationFilters.length) {
            this.$emit('next')
          } else {
            this.getIndicators({method: 'get', url: 'api/indication', headers: this.paginationFilters[this.index]}).then((response) => {
              this.indicators = response
            })
          }
        }
      }, (process.env.REFRESH_TIME * 1000))
    })
    this.getIndicators({method: 'get', url: 'api/indication', headers: this.paginationFilters[this.index]}).then((response) => {
      this.indicators = response
    })
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.refresh)
  },
  data () {
    return {
      index: 0,
      indicators: [],
      timer: undefined,
      trimester: ['first', 'second', 'third', 'fourth']
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      kioskId: state => state.auth.kiosk.id,
      company: state => state.auth.company
    }),
    paginationFilters () {
      return [{area: 'G', company: this.company, period: 'A'}, {area: 'G', company: this.company, period: 'T'}, {area: 'C', company: this.company}]
    }
  },
  methods: {
    ...mapActions({
      getIndicators: 'requestIndicators'
    })
  }
}
</script>

<style scoped lang="scss">
.indicators{
  display: flex;
  flex-wrap:wrap;
  justify-content: center;
}
.sub-title{
  font-size: .6em;
  display: block;
  color: #B6BF05;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageIndicators.vue